import { useState } from 'react';
import MoreMenu from '@components/MoreMenu';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useTranslation } from '@hooks';
import { handleApiError } from '@helpers/api';

const ExportCSV = ({ type, apiCall }) => {
    const [anchor, setAnchor] = useState({ el: null, id: null });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { t } = useTranslation();

    const handleOpen = (event, id) => {
        event.stopPropagation();
        setAnchor({ id, el: event.currentTarget });
    };

    const handleClose = () => setAnchor(prev => ({ ...prev, el: null }));

    const onExport = async () => {
        try {
            setIsSubmitting(true);
            const file = await apiCall();
            const anchor = document.createElement('a');
            anchor.style.display = 'none';
            anchor.href = file;
            anchor.download = `${type}.csv`;
            document.body.appendChild(anchor);
            anchor.click();
            window.URL.revokeObjectURL(file);
            anchor.remove();
        } catch (error) {
            handleApiError(error);
        } finally {
            handleClose();
            setIsSubmitting(false);
        }
    };

    const menu = [
        {
            id: type,
            icon: <FileDownloadIcon sx={{ height: '18px', width: '18px' }} />,
            title: t('buttons.export'),
            onClick: () => onExport(type),
            disabled: isSubmitting,
        },
    ];

    return <MoreMenu id={type} anchor={anchor} handleOpenEl={handleOpen} handleCloseEl={handleClose} menu={menu} />;
};

export default ExportCSV;
